import { useState, useEffect } from 'react';
import { api } from '../api/client.js';
import VpnRequired from './VpnRequired.jsx';

export default function VpnGate({ children }) {
  const [state, setState] = useState('checking'); // 'checking' | 'allowed' | 'blocked'

  const check = async () => {
    setState('checking');
    try {
      // Hit a real VPN-gated endpoint. Use validateStatus so axios returns 4xx
      // responses instead of throwing — we want to inspect the body.
      const r = await api.get('/api/auth/session', {
        validateStatus: (s) => s < 500
      });
      if (r.status === 403 && r.data?.error === 'vpn_required') {
        setState('blocked');
      } else {
        // 200 (logged in) or 401 (not logged in) — both mean VPN is OK
        setState('allowed');
      }
    } catch (e) {
      // No response = network blocked (CORS preflight failure, TCP drop, etc.)
      if (!e.response) {
        setState('blocked');
      } else if (e.response.status === 403 && e.response.data?.error === 'vpn_required') {
        setState('blocked');
      } else {
        // Some other error — let normal flow handle it
        setState('allowed');
      }
    }
  };

  useEffect(() => {
    check();
  }, []);

  if (state === 'checking') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="text-sm text-muted">Loading…</div>
      </div>
    );
  }

  if (state === 'blocked') {
    return <VpnRequired onRetry={check} />;
  }

  return children;
}